import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { CATEGORIES } from '@perpay-web/fintech/components/composite/SpendingLimitLanding/ExploreCategoriesGrid/categories';
import { useShopPath } from '@perpay-web/fintech/hooks/useShopPath';

import styles from './ExploreCategoriesGrid.scss';

const ExploreCategoriesGrid = () => {
    const { getCategoryHref } = useShopPath();

    return (
        <div className={styles['categories-bottom-sheet']}>
            <p className={styles.subheading}>Explore Categories</p>
            <div className={styles['category-carousel']}>
                {CATEGORIES.map(({ title, link, image }) => (
                    <CustomLink
                        key={title}
                        href={getCategoryHref(link)}
                        action='inline-link'
                        className={styles['category-link']}
                    >
                        <div className={styles['category-item']}>
                            <img
                                className={styles['category-image']}
                                src={image}
                                alt={`${title} Category`}
                            />
                        </div>
                        <div className={styles['category-title']}>{title}</div>
                    </CustomLink>
                ))}
            </div>
        </div>
    );
};

export default ExploreCategoriesGrid;
